class FinancialSummary {
  constructor(params) {
    this.excessAmountTotal = params.excessAmountTotal;
    this.excessAmountConsumed = params.excessAmountConsumed;
    this.excessAmountRemaining = params.excessAmountRemaining;
    this.excessPercentageConsumed = params.excessPercentageConsumed;

    this.gvsAmountTotal = params.gvsAmountTotal;
    this.gvsAmountConsumed = params.gvsAmountConsumed;
    this.gvsAmountRemaining = params.gvsAmountRemaining;
    this.gvsPercentageConsumed = params.gvsPercentageConsumed;

    this.dentalAmountTotal = params.dentalAmountTotal;
    this.dentalAmountConsumed = params.dentalAmountConsumed;
    this.dentalAmountRemaining = params.dentalAmountRemaining;
    this.dentalPercentageConsumed = params.dentalPercentageConsumed;
  }
}
export { FinancialSummary as default };
